import { Component, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.less']
})
export class VersionComponent implements OnInit {

  currentVersion: string = "";
  buildDate: any = {};
  buildDateTime: any;
  constructor() { }

  ngOnInit(): void {
    this.currentVersion = "ITC-Opera-1.2.1";
    this.buildDate = new Date('2024-05-02');
    this.buildDateTime = moment(this.buildDate, 'YYYY-MM-DD').format("DD/MM/YYYY");
  }

}
